export const PARTNER_PORTAL_TOUR_TARGETS = {
  profileMenuButton: "partner-portal-tour-profile-menu-button",
  installMenuItem: "partner-portal-tour-install-menu-item",
  notificationsButton: "partner-portal-tour-notifications-button",
  helpMenuItem: "partner-portal-tour-help-menu-item",
  searchModeButton: "partner-portal-tour-search-mode-button",
  barcodeButton: "partner-portal-tour-barcode-button",
  assistantButton: "partner-portal-tour-assistant-button",
} as const;
